
import React ,{ Component } from 'react';
import {Container, Row, Col,Form,Button,Image} from 'react-bootstrap';
import { withRouter,Link } from "react-router-dom";
import loader from '../../images/loader.gif'; 
import '../ProfileDetails/ProfileDetails';
import SelectBox from '../SelectDropDown/SelectDropDown';
import { components } from 'react-select';
import SuccessMessagePopup from './SuccessMessagePopup';

const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
  };

  
export async function getAPICallDataLocalMember(data,url) {
    
    const response  =    fetch('https://www.mypartydashboard.com/BSA/WebService/'+url, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
     body: data
  })

   return response;
}
class PanchayatDetails extends Component {
    constructor(props) {
        super(props)
        this.state = {
            ap_listArr:[{'value':108,'label':'AMADALAVALASA'},{'value':109,'label':'ETCHERLA'},{'value':111,'label':'ICHAPURAM'},{'value':112,'label':'NARASANNAPETA'},{'value':113,'label':'PALAKONDA'},{'value':114,'label':'PATHAPATNAM'},{'value':116,'label':'SRIKAKULAM'},{'value':117,'label':'TEKKALI'},{'value':120,'label':'CHEEPURUPALLI'},{'value':121,'label':'GAJAPATHINAGARAM'},{'value':122,'label':'BOBBILI'},{'value':124,'label':'PARVATHIPURAM'},{'value':125,'label':'SALUR'},{'value':127,'label':'SRUNGAVARAPUKOTA'},{'value':129,'label':'VIZIANAGARAM'},{'value':133,'label':'ANAKAPALLI'},{'value':134,'label':'CHODAVARAM'},{'value':135,'label':'ELAMANCHILI'},{'value':136,'label':'MADUGULA'},{'value':137,'label':'NARSIPATNAM'},{'value':138,'label':'PADERU'},{'value':140,'label':'PAYAKARAOPETA'},{'value':141,'label':'PENDURTHI'},{'value':146,'label':'AMALAPURAM'},{'value':147,'label':'ANAPARTHY'},{'value':149,'label':'JAGGAMPETA'},{'value':152,'label':'KOTHAPETA'},{'value':153,'label':'MUMMIDIVARAM'},{'value':155,'label':'PEDDAPURAM'},{'value':156,'label':'PITHAPURAM'},{'value':157,'label':'PRATHIPAD'},{'value':159,'label':'RAMACHANDRAPURAM'},{'value':160,'label':'RAZOLE'},{'value':163,'label':'TUNI'},{'value':167,'label':'BHIMAVARAM'},{'value':168,'label':'CHINTALAPUDI'},{'value':169,'label':'DENDULUR'},{'value':170,'label':'ELURU'},{'value':171,'label':'GOPALPURAM'},{'value':172,'label':'KOVVUR'},{'value':173,'label':'NARASAPUR'},{'value':174,'label':'PALACOLE'},{'value':176,'label':'POLAVARAM'},{'value':177,'label':'TADEPALLIGUDEM'},{'value':178,'label':'TANUKU'},{'value':179,'label':'UNDI'},{'value':180,'label':'UNGUTUR'},{'value':181,'label':'ACHANTA'},{'value':182,'label':'AVANIGADDA'},{'value':184,'label':'GANNAVARAM (KRISHNA)'},{'value':185,'label':'GUDIVADA'},{'value':186,'label':'JAGGAYYAPET'},{'value':187,'label':'KAIKALUR'},{'value':191,'label':'MYLAVARAM'},{'value':192,'label':'NANDIGAMA'},{'value':193,'label':'NUZVID'},{'value':194,'label':'TIRUVURU'},{'value':195,'label':'VIJAYAWADA EAST'},{'value':196,'label':'VIJAYAWADA WEST'},{'value':199,'label':'CHILAKALURIPET'},{'value':203,'label':'GURZALA'},{'value':205,'label':'MACHERLA'},{'value':206,'label':'MANGALAGIRI'},{'value':207,'label':'VINUKONDA'},{'value':208,'label':'NARASARAOPET'},{'value':209,'label':'BAPATLA'},{'value':210,'label':'PEDDAKURAPADU'},{'value':211,'label':'PONNUR'},{'value':212,'label':'PRATHIPADU'},{'value':213,'label':'REPALLE'},{'value':214,'label':'SATTENAPALLI'},{'value':215,'label':'TADIKONDA'},{'value':216,'label':'TENALI'},{'value':217,'label':'VEMURU'},{'value':218,'label':'ADDANKI'},{'value':219,'label':'CHIRALA'},{'value':221,'label':'DARSI'},{'value':222,'label':'GIDDALUR'},{'value':223,'label':'KANDUKUR'},{'value':224,'label':'KANIGIRI'},{'value':225,'label':'KONDEPI'},{'value':226,'label':'MARKAPUR'},{'value':227,'label':'ONGOLE'},{'value':228,'label':'PARCHUR'},{'value':229,'label':'SANTHANUTHALAPADU'},{'value':231,'label':'GUDUR'},{'value':232,'label':'KAVALI'},{'value':233,'label':'KOVUR'},{'value':236,'label':'SARVEPALLI'},{'value':237,'label':'SULLURPET'},{'value':238,'label':'UDAYAGIRI'},{'value':239,'label':'VENKATAGIRI'},{'value':241,'label':'ATMAKUR'},{'value':242,'label':'BADVEL'},{'value':243,'label':'KADAPA'},{'value':244,'label':'JAMMALAMADUGU'},{'value':245,'label':'KAMALAPURAM'},{'value':246,'label':'KODUR'},{'value':248,'label':'RAYACHOTY'},{'value':249,'label':'MYDUKUR'},{'value':250,'label':'PRODDATUR'},{'value':251,'label':'PULIVENDLA'},{'value':252,'label':'RAJAMPET'},{'value':253,'label':'ADONI'},{'value':254,'label':'ALLAGADDA'},{'value':255,'label':'ALUR'},{'value':257,'label':'DHONE'},{'value':258,'label':'KODUMUR'},{'value':260,'label':'KURNOOL'},{'value':261,'label':'NANDIKOTKUR'},{'value':262,'label':'NANDYAL'},{'value':263,'label':'PANYAM'},{'value':264,'label':'PATTIKONDA'},{'value':265,'label':'YEMMIGANUR'},{'value':267,'label':'DHARMAVARAM'},{'value':270,'label':'HINDUPUR'},{'value':271,'label':'KADIRI'},{'value':272,'label':'KALYANDURG'},{'value':273,'label':'MADAKASIRA'},{'value':275,'label':'PENUKONDA'},{'value':276,'label':'RAYADURG'},{'value':277,'label':'SINGANAMALA'},{'value':278,'label':'TADPATRI'},{'value':279,'label':'URAVAKONDA'},{'value':280,'label':'CHANDRAGIRI'},{'value':281,'label':'CHITTOOR'},{'value':282,'label':'KUPPAM'},{'value':283,'label':'NAGARI'},{'value':284,'label':'PALAMANER'},{'value':285,'label':'PILERU'},{'value':286,'label':'PUNGANUR'},{'value':288,'label':'SATYAVEDU'},{'value':289,'label':'SRIKALAHASTI'},{'value':290,'label':'THAMBALLAPALLE'},{'value':291,'label':'TIRUPATI'},{'value':294,'label':'MADANPALLE'},{'value':297,'label':'GUNTAKAL'},{'value':298,'label':'ANANTAPUR URBAN'},{'value':299,'label':'RAPTADU'},{'value':300,'label':'PUTTAPARTHI'},{'value':301,'label':'GANGADHARA NELLORE'},{'value':302,'label':'PUTHALAPATTU'},{'value':303,'label':'RAJANAGARAM'},{'value':304,'label':'RAJAHMUNDRY CITY'},{'value':305,'label':'RAJAHMUNDRY RURAL'},{'value':306,'label':'RAMPACHODAVARAM'},{'value':307,'label':'KAKINADA RURAL'},{'value':308,'label':'KAKINADA CITY'},{'value':309,'label':'MANDAPETA'},{'value':310,'label':'GANNAVARAM (EG)'},{'value':311,'label':'GUNTUR EAST'},{'value':312,'label':'GUNTUR WEST'},{'value':327,'label':'PEDANA'},{'value':328,'label':'MACHILIPATNAM'},{'value':329,'label':'PAMARRU'},{'value':330,'label':'PENAMALURU'},{'value':331,'label':'VIJAYAWADA CENTRAL'},{'value':332,'label':'SRISAILAM'},{'value':333,'label':'BANAGANAPALLE'},{'value':334,'label':'MANTRALAYAM'},{'value':340,'label':'NELLORE CITY'},{'value':341,'label':'NELLORE RURAL'},{'value':344,'label':'YERRAGONDAPALEM'},{'value':352,'label':'PALASA'},{'value':353,'label':'RAJAM'},{'value':354,'label':'VISAKHAPATNAM EAST'},{'value':355,'label':'VISAKHAPATNAM SOUTH'},{'value':356,'label':'VISAKHAPATNAM NORTH'},{'value':357,'label':'VISAKHAPATNAM WEST'},{'value':358,'label':'GAJUWAKA'},{'value':359,'label':'ARAKU VALLEY'},{'value':360,'label':'KURUPAM'},{'value':361,'label':'NELLIMARLA'},{'value':366,'label':'NIDADAVOLE'},{'value':368,'label':'BHIMILI'}],
            constituencyName:"",
            constituencyValue:"",
            participate_ele_arr:[{'value':'Sarpanch','label':'Sarpanch'},{'value':'Ward Member','label':'Ward Member'},{'value':'MPTC','label':'MPTC'},{'value':'ZPTC','label':'ZPTC'},{'value':'Counsilor','label':'Counsilor'},{'value':'Corporate','label':'Corporate'}],
            parElectionValue:"",
            parElection:"",
            prYesCheckedId:false,
            prNoCheckedId:false,
            election_year_arr:[{'value':1980,'label':'1980'},{'value':1981,'label':'1981'},{'value':1982,'label':'1982'},{'value':1983,'label':'1983'},{'value':1984,'label':'1984'},{'value':1985,'label':'1985'},{'value':1986,'label':'1986'},{'value':1987,'label':'1987'},{'value':1988,'label':'1988'},{'value':1989,'label':'1989'},{'value':1990,'label':'1990'},{'value':1991,'label':'1991'},{'value':1992,'label':'1992'},{'value':1993,'label':'1993'},{'value':1994,'label':'1994'},{'value':1995,'label':'1995'},{'value':1996,'label':'1996'},{'value':1997,'label':'1997'},{'value':1998,'label':'1998'},{'value':1999,'label':'1999'},{'value':2000,'label':'2000'},{'value':2001,'label':'2001'},{'value':2002,'label':'2002'},{'value':2003,'label':'2003'},{'value':2004,'label':'2004'},{'value':2005,'label':'2005'},{'value':2006,'label':'2006'},{'value':2007,'label':'2007'},{'value':2008,'label':'2008'},{'value':2009,'label':'2009'},{'value':2010,'label':'2010'},{'value':2011,'label':'2011'},{'value':2012,'label':'2012'},{'value':2013,'label':'2013'},{'value':2014,'label':'2014'},{'value':2015,'label':'2015'},{'value':2016,'label':'2016'},{'value':2017,'label':'2017'},{'value':2018,'label':'2018'},{'value':2019,'label':'2019'},{'value':2020,'label':'2020'},{'value':2021,'label':'2021'},{'value':2022,'label':'2022'},{'value':2023,'label':'2023'}],
            electionYearValue:"",
            electionYear:"",
            mobileNo:"",
            validatemobileNo:"",
            participateValue:"",
            validateparticipateValue:"",
            validateconstituencyName:"",
            validateparElection:"",
            validateelectionYear:"",
            SuccessMessageModal:false,
            memberName:"",
            validatememberName:"",
            locationMemberLoadingSymbol:"hide",
            messageString:""
        }
    }
  
    componentDidMount() {
        this.setState({ap_listArr:this.state.ap_listArr.sort((a, b) => a.label.localeCompare(b.label))})
    }

    handleOnchangeSelectBoxNew = (ename, evalue) =>{
        const name = ename;
        const value = evalue;
    
        if(name == "constituencyName"){
            let getConsIdName = this.state.ap_listArr.find((a) => a.value == value);
                this.setState({
                    constituencyValue: {
                    value: getConsIdName.value,
                    label: getConsIdName.label
                }
            });
           // this.serchOptionGetBooths(value);
        }else if(name == "parElection"){
            let getIdName = this.state.participate_ele_arr.find((a) => a.value == value);
            this.setState({
                parElectionValue: {
                value: getIdName.value,
                label: getIdName.label
            }
        });
           
        }else if(name == "electionYear"){
            let getIdName = this.state.election_year_arr.find((a) => a.value == value);
            this.setState({
                electionYearValue: {
                value: getIdName.value,
                label: getIdName.label
            }
        });
           
        }
          
    
        this.setState({ [name]: value});
      }

      handleOnchangeInputBox = (e) => {
        console.log("handleInputChange", e.target.name, e.target.value)
        const name = e.target.name;
        const value = e.target.value;

        this.setState({ [name]: value });
        
      }

    checkPRParameterValue = (e,value) => {
        if(value == 'Y'){
            this.setState({prYesCheckedId:true,prNoCheckedId:false})
        }else if(value == 'N'){
            this.setState({prYesCheckedId:false,prNoCheckedId:true})
        }
        this.setState({participateValue:value})
    }
    formSubmitted = () => {
        this.setState({validatemobileNo:"",validateparticipateValue:"",validateconstituencyName:"",validateparElection:"",validateelectionYear:"" });
        var expr = /^(0|91)?[6-9][0-9]{9}$/;

        if(this.state.constituencyName == ""){
            this.setState({validateconstituencyName:"Please Select Constituency Name" });
            return;
        }
        if(this.state.parElection == ""){
            this.setState({validateparElection:"Please Select Election Type" });
            return;
        }
        if(this.state.electionYear == ""){
            this.setState({validateelectionYear:"Please Select Election Year" });
            return;
        }

        if(this.state.memberName == ""){
            this.setState({validatememberName:"Please Enter Name" });
            return;
        }

        if(this.state.mobileNo == ""){
            this.setState({validatemobileNo:"Please Enter Mobile No" });
            return;
        }

        if(!expr.test(this.state.mobileNo)){
            this.setState({validatemobileNo:"Please Enter Valid Mobile No" });
            return;
          }

        if(this.state.mobileNo.length < 10){
            this.setState({validatemobileNo:"Please Enter Valid Mobile No" });
            return;
        }

        if(this.state.participateValue == ""){
            this.setState({validateparticipateValue:"Please Check Atleast One" });
            return;
        }

        this.setState({locationMemberLoadingSymbol:"show"})

        const obj =  
        JSON.stringify({ 
            "constituencyId" : this.state.constituencyName,
            "electionType" : this.state.parElection,
            "year" : this.state.electionYear,
            "memberName" : this.state.memberName,
            "mobileNo" : this.state.mobileNo,
            "isInterested" : this.state.participateValue
        });
    
    

    getAPICallDataLocalMember(obj,"saveLocalBodyMember")
    .then((response) => {
        this.setState({locationMemberLoadingSymbol:"hide"})
        if (response.ok) {
          return response.json();
        }
        return Promise.reject(response); 
      })
      .then((json) => {
        if(json !=null && json.status == "Success"){
            this.setState({SuccessMessageModal:true})
            setTimeout(() => { 
                window.location.href="https://t.me/+u7x_cbOPmPo0NjBl";
            }, 2000);
        }else if(json.status == "Fail"){
            this.setState({messageString:"Something Wrong,Please Try Again..."});
        }else{
            this.setState({messageString:"Something Wrong,Please Try Again..."});
        }
        
      })
      .catch((response) => {
        if(response !=null && response.status == "Fail"){
            this.setState({messageString:"Something Wrong,Please Try Again..."});
        }else{
            this.setState({messageString:"Something Wrong,Please Try Again..."});
        }
        // 3. get error messages, if any
        response.json().then((json) => {
            if(json !=null && json.status == "Fail"){
                this.setState({messageString:"Something Wrong,Please Try Again..."});
            }else{
                this.setState({messageString:"Something Wrong,Please Try Again..."});
            }
        })
      });

        
       
    }

    closeSuccessModal = () => {
        this.setState({SuccessMessageModal:false});
        this.setState({
            constituencyName:"",
            constituencyValue:"",
            parElectionValue:"",
            parElection:"",
            prYesCheckedId:false,
            prNoCheckedId:false,
            electionYearValue:"",
            electionYear:"",
            mobileNo:"",
            validatemobileNo:"",
            participateValue:"",
            validateparticipateValue:"",
            validateconstituencyName:"",
            validateparElection:"",
            validateelectionYear:"",
            memberName:"",
            locationMemberLoadingSymbol:"hide",
            messageString:""
        });

        this.setState({ap_listArr:this.state.ap_listArr.sort((a, b) => a.label.localeCompare(b.label))});
    }

    render() {
        return (
            <section className=''>
                <Container >
                    <Row>
                        <Col className='mt-4'>
                            <h5 className='fw-bold text-center ln-28 f-18'>మీరు ప్రస్తుత లేదా మాజీ <span className='color_green f-22'> గ్రామా సర్పంచులు, వార్డ్ , మున్సిపల్ వార్డ్ మెంబెర్స్ , మునిసిపల్ ఛైర్మన్స్ , ఎంపీటీసీ , జడ్పీటీసీ , కార్పొరేషన్ డివిజన్</span> మెంబెర్స్ అయినవారు పంచాయతి రాజ్ మహోత్సవ్ ఉద్యమంలో మీరు భాగస్వామ్యులు అవ్వండి, ఈ కార్యక్రమం యొక్క ముఖ్య సమాచారం నిరంతరం తెలుసుకొనుట కోసం మీ వివరాలు తెలియజేయగలరు.</h5>
                        </Col>
                    </Row>
                    <Row className='justify-content-center'>
                        <Col sm={4}>
                            <Row>
                                <Col>
                                    <Form.Group className="mt-2" controlId="formConstituencyNameId">
                                        <Form.Label className='f-12 fw-bold'>Constituency/నియోజకవర్గం: <span className='color_red f-9'>{this.state.validateconstituencyName}</span></Form.Label>
                                        <SelectBox
                                            stateData={this.state.constituencyValue}
                                            handleChange={this.handleOnchangeSelectBoxNew}
                                            name="constituencyName"
                                            options={this.state.ap_listArr}
                                            placeholderName={'Constituency'}
                                            dropdownIndicator={{ DropdownIndicator }}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Group className="mt-2" controlId="formConstituencyNameId">
                                        <Form.Label className='f-12 fw-bold'>Participated Election/ఎ ఎన్నికలలో పోటీచేశారు : <span className='color_red f-9'>{this.state.validateparElection}</span></Form.Label>
                                        <SelectBox
                                            stateData={this.state.parElectionValue}
                                            handleChange={this.handleOnchangeSelectBoxNew}
                                            name="parElection"
                                            options={this.state.participate_ele_arr}
                                            placeholderName={'Election'}
                                            dropdownIndicator={{ DropdownIndicator }}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Group className="mt-2" controlId="formYearId">
                                        <Form.Label className='f-12 fw-bold'>Year/ఇయర్ : <span className='color_red f-9'>{this.state.validateelectionYear}</span></Form.Label>
                                        <SelectBox
                                            stateData={this.state.electionYearValue}
                                            handleChange={this.handleOnchangeSelectBoxNew}
                                            name="electionYear"
                                            options={this.state.election_year_arr}
                                            placeholderName={'Year'}
                                            dropdownIndicator={{ DropdownIndicator }}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Group className="mt-2" controlId="formNameId">
                                        <Form.Label className='f-12 fw-bold'>Name/పేరు : <span className='color_red f-9'>{this.state.validatememberName}</span></Form.Label>
                                        <Form.Control type="text" name="memberName" className='form-control-sm' value={this.state.memberName}  placeholder="Enter Name" onChange={(e) => this.handleOnchangeInputBox(e)}/>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Group className="mt-2" controlId="formMobileId">
                                        <Form.Label className='f-12 fw-bold'>Mobile No/ఫోన్ నెంబర్ : <span className='color_red f-9'>{this.state.validatemobileNo}</span></Form.Label>
                                        <Form.Control type="text" name="mobileNo" className='form-control-sm' value={this.state.mobileNo} placeholder="Enter Mobile No" onChange={(e) => this.handleOnchangeInputBox(e)}/>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Label className='mt-2 f-12 fw-bold mb-1'>Interested To Participate in Panchayat Raj Mahotsava : </Form.Label>
                                        <h6 className='center-auto'>
                                            
                                            <Form.Check
                                                inline
                                                label={"Yes"}
                                                name="interestedValuePr"
                                                type="radio"
                                                id="prYesId"
                                                onChange={(e)=>this.checkPRParameterValue(e,'Y')}
                                                className="color_green f-16  fw-bold ml-3"
                                                checked={this.state.prYesCheckedId}
                                            />
                                            
                                            <Form.Check
                                                inline
                                                label={"No"}
                                                name="interestedValuePr"
                                                type="radio"
                                                id="prNoId"
                                                onChange={(e)=>this.checkPRParameterValue(e,'N')}
                                                className="color_red f-16 fw-bold"
                                                checked={this.state.prNoCheckedId}
                                            />
                                        
                                    </h6>
                                    <span className='color_red f-9'>{this.state.validateparticipateValue}</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Button variant="outline-danger" className='f-14  fw-bold  mt-1 center-auto' onClick={() => this.formSubmitted()}>SUBMIT
                                    {
                                        this.state.locationMemberLoadingSymbol === "show" ? (<Image src={loader} alt="loader" className='loader_cls ms-2'></Image>) : ("")
                                    }
                                    </Button> 
                                </Col>
                            </Row>

                            {
                                this.state.messageString != "" ?
                                (
                                    <Row>
                                        <Col>
                                            <h6 className='text-center color_red f-18'>{this.state.messageString}</h6>
                                        </Col>
                                    </Row>
                                )
                                :
                                ("")
                            }

                           
                        </Col>
                    </Row>
                    
                </Container>
                <SuccessMessagePopup 
                        show={this.state.SuccessMessageModal}
                        stateData={this.state}
                        closeSuccessModal={this.closeSuccessModal}
                />
            </section>
        )
    }
  }
  
  export default withRouter(PanchayatDetails);
  